import {CommonMessages} from '../common.messages';

export const PanelBankAccountsEditMessages = {
    GetBankAccountFailed: {
        key: 'GetBankAccountFailed',
        message: 'Error while communication with the server. Unable to get bank account information.'
    },
    BankAccountNotFound: {
        key: 'BankAccountNotFound',
        message: 'Error while communication with the server. Unable to find information about bank account.'
    },
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Unable to get client information.'
    },
    ClientNotFound: {
        key: 'ClientNotFound',
        message: 'Error while communication with the server. Unable to find information about client.'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Unable to get available countries.'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Countries data is corrupted.'
    },
    UpdateBankAccountFailed: {
        key: 'UpdateBankAccountFailed',
        message: 'Error while request to the server. Unable to update bank account details.'
    },
    DeleteBankAccountRestricted: {
        key: 'DeleteBankAccountRestricted',
        message: 'For bank account deactivation are required additional permissions.'
    },
    ...CommonMessages
};
